/**
 * Convert number block conditions to Formly hideExpression
 * Handles: number block
 */

export interface NumberConditionProps {
	mode: 'equal' | 'below' | 'above' | 'between' | 'defined' | 'undefined';
	value?: number;
	to?: number;
}

/**
 * Convert a number condition to hideExpression
 * Returns expression that evaluates to TRUE when condition is MET
 * (Remember: hideExpression hides when TRUE, so we'll invert later)
 */
export function convertNumberCondition(fieldKey: string, props: NumberConditionProps): string | undefined {
	const { mode, value, to } = props;

	switch (mode) {
		case 'equal':
			// Field value must equal the specified number
			if (value === undefined || value === null) {
				return undefined;
			}
			return `model['${fieldKey}'] === '${value}'`;

		case 'below':
			// Field value must be less than the specified number
			if (value === undefined || value === null) {
				return undefined;
			}
			return `model['${fieldKey}'] < '${value}'`;

		case 'above':
			// Field value must be greater than the specified number
			if (value === undefined || value === null) {
				return undefined;
			}
			return `model['${fieldKey}'] > '${value}'`;

		case 'between':
			// Field value must be between two numbers (inclusive)
			if (value === undefined || value === null || to === undefined || to === null) {
				return undefined;
			}
			return `(model['${fieldKey}'] >= '${value}' && model['${fieldKey}'] <= '${to}')`;

		case 'defined':
			// Field must have a value (not null, not undefined, not empty)
			return `(model['${fieldKey}'] !== null && model['${fieldKey}'] !== undefined && model['${fieldKey}'] !== '')`;

		case 'undefined':
			// Field must be empty, null, or undefined
			return `(model['${fieldKey}'] === null || model['${fieldKey}'] === undefined || model['${fieldKey}'] === '')`;

		default:
			// Unknown mode
			return undefined;
	}
}
